export default [
  'Navy',
  'Marine Corps'
]
